/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
/**
 * Program: i18n
 * Author: SDL
 * Description: i18n language setting file
 */
// https://kazupon.github.io/vue-i18n/guide/lazy-loading.html
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import StringUtil from '@/utils/StringUtil';

Vue.use(VueI18n);

console.log('i18n Index.js Language');
console.log(window.navigator.userLanguage);
console.log(window.navigator.language);
const initDefaultLang = 'ko_KR';

const defaultLanguage = (initDefaultLang || window.navigator.language || window.navigator.userLanguage).replace('-', '_');
export const i18n = new VueI18n({
  locale: defaultLanguage, // set locale
  fallbackLocale: defaultLanguage,
  messages: {}, // set locale messages
});
console.log('i18n language');
console.log(i18n);

let loadedLanguages = []; // our default language that is preloaded

function setI18nLanguage(lang) {
  console.log('setI18nLanguage language');
  console.log(lang);
  i18n.locale = lang;
  store.commit('LOCALE', lang);
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export async function loadLanguageAsync(lang) {
  console.log('loadLanguageAsync language');
  console.log(lang);
  console.log(loadedLanguages);
  let language;
  if (isEmpty(loadedLanguages)) {
    // await axios.get(`${SDLUtil.API_URL}/noauth/messages/all`).then(msgs => {
    const params = {
      locale: lang,
    };
    const listApi = `${SDLUtil.API_URL}/noauth/messages?${StringUtil.queryStringfy(
      params,
    )}`;
    await axios.get(listApi).then(msgs => {
      console.log('noauth/messages');
      console.log(msgs.data);
      loadedLanguages = Object.keys(msgs.data);
      loadedLanguages.forEach(country => {
        console.log('loadedLanguages foreach');
        console.log(country);
        console.log(msgs.data[country]);
        i18n.setLocaleMessage(country, msgs.data[country]);
      });
    });
  }
  try {
    console.log('loadLanguageAsync try');
    console.log(loadedLanguages.find(find => find === lang));
    console.log(loadedLanguages.find(find => find.includes(lang.split('_')[0])));
    console.log(SDLUtil.DEFAULT_LANG);
    language = SDLUtil.DEFAULT_LANG
      || loadedLanguages.find(find => find === lang)
      || loadedLanguages.find(find => find.includes(lang.split('_')[0]));
  } catch (e) {
    language = SDLUtil.DEFAULT_LANG;
  }
  console.log('loadLanguageAsync Result');
  console.log(language);
  return setI18nLanguage(language);
}

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js